<template lang="html">
  <button class="btn" v-bind="$attrs" v-on="$listeners" @click="report" @submit="report"><slot></slot></button>
</template>

<script>
import Nazgul from "@/services/nazgul";
export default {
  name: "h-btn",
  props: ["event", "eventType"],
  methods: {
    report() {
      if (this.event) {
        Nazgul.report(this.event, this.eventType || "");
      }
    }
  }
};
</script>

<style lang="less" scoped>
</style>
